import { getHostname } from './dom';
import { extractTopLevelDomain } from './tld';
var DefaultCountry = 'IE';
export var getCurrentCountry = function () {
    try {
        var hostname = getHostname();
        var tld = extractTopLevelDomain(hostname);
        switch (tld.toLowerCase()) {
            case 'pt':
                return 'PT';
            case 'ie':
                return 'IE';
            case 'es':
                return 'ES';
            case 'in':
                return 'IN';
            case 'jp':
                return 'JP';
            case 'com':
                return 'US';
            case 'fr':
                return 'FR';
            case 'it':
                return 'IT';
            case 'uk':
                return 'GB';
            case 'de':
                return 'DE';
            case 'nl':
                return 'NL';
            case 'dk':
                return 'DK';
            case 'se':
                return 'SE';
            case 'at':
                return 'AT';
            case 'no':
                return 'NO';
            case 'fi':
                return 'FI';
            case 'be':
                return 'BE';
            case 'sg':
                return 'SG';
            case 'nz':
                return 'NZ';
            case 'au':
                return 'AU';
            case 'ca':
                return 'CA';
            case 'ch':
                return 'CH';
            default:
                return DefaultCountry;
        }
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error.message, "Fallback country: " + DefaultCountry);
        return DefaultCountry;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvY291bnRyeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ3BDLE9BQU8sRUFBRSxxQkFBcUIsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUU5QyxJQUFNLGNBQWMsR0FBRyxJQUFJLENBQUM7QUFFNUIsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQWlCO0lBQzdDLElBQUk7UUFDRixJQUFNLFFBQVEsR0FBVyxXQUFXLEVBQUUsQ0FBQztRQUN2QyxJQUFNLEdBQUcsR0FBVyxxQkFBcUIsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUVwRCxRQUFRLEdBQUcsQ0FBQyxXQUFXLEVBQUUsRUFBRTtZQUN6QixLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLEtBQUs7Z0JBQ1IsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZCxLQUFLLElBQUk7Z0JBQ1AsT0FBTyxJQUFJLENBQUM7WUFDZDtnQkFDRSxPQUFPLGNBQWMsQ0FBQztTQUN6QjtLQUNGO0lBQUMsT0FBTyxLQUFLLEVBQUU7UUFDZCxzQ0FBc0M7UUFDdEMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxFQUFFLHVCQUFxQixjQUFnQixDQUFDLENBQUM7UUFFbkUsT0FBTyxjQUFjLENBQUM7S0FDdkI7QUFDSCxDQUFDLENBQUMifQ==